// 定义内容
export default {
	login: {
		placeholder1: '用户名 admin 或不输均为 test',
		placeholder2: '密码：123456',
		placeholder3: '请输入验证码',
		btnText: '登 录',
		link: {
			one1: '第三方登录',
			one2: '友情链接',
		},
		signInText: '欢迎回来！',
		copyright: {
			one5: '版权所有：深圳市xxx软件科技有限公司',
			two6: 'Copyright: Shenzhen XXX Software Technology 粤ICP备05010000号',
		},
	},
};
